import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { AppBar, primaryBtnCls } from '../ui';

/**
 * IXVerify — tool-unavailable screen (ixv2 WP-0.2).
 *
 * The v1 module was deleted; /ixverify/* renders this platform-standard
 * "not available" page (the LMS Coming Soon pattern) until the v2 module
 * lands and is enabled (kill switches REACT_APP_IXVERIFY_ENABLED /
 * IXVERIFY_ENABLED stay unset until WP-6.1).
 */
const IXVerifyUnavailable: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <AppBar />
      <main className="mx-auto w-full max-w-2xl px-4 pt-16 pb-6 sm:px-6">
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/30">
            <ShieldCheck size={32} className="text-primary-600 dark:text-primary-400" aria-hidden="true" />
          </div>
          <h1 className="mb-1 text-lg font-semibold text-gray-900 dark:text-gray-100">
            IXVerify is not available right now
          </h1>
          <p className="max-w-sm text-sm text-gray-500 dark:text-gray-400">
            Investigational product dispensing verification is being rebuilt.
            Check back soon, or contact your administrator for more information.
          </p>
          <Link to="/" className={`${primaryBtnCls} mt-6`}>
            Back to Tool Hub
          </Link>
        </div>
      </main>
    </div>
  );
};

export default IXVerifyUnavailable;
